package org.example.zone360.sections

import org.example.zone360.components.debugPrintln

import CancelSubscriptionPopup
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaBell
import com.varabyte.kobweb.silk.components.icons.fa.FaSortDown
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.getNotifications
import kotlinx.browser.document
import kotlinx.browser.localStorage
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.MenuDropdown
import org.example.zone360.components.ShimmerCircle
import org.example.zone360.components.showToast
import org.example.zone360.components.titleized
import org.example.zone360.models.MenuModel
import org.example.zone360.models.UserData
import org.example.zone360.pages.authentication.AddDirector
import org.example.zone360.pages.authentication.ChangeEmailPage
import org.example.zone360.pages.authentication.ChangePasswordPage
import org.example.zone360.pages.dashboard.coaches.notifications.NotificationUiModel
import org.example.zone360.pages.dashboard.coaches.notifications.NotificationsDropdown
import org.example.zone360.pages.dashboard.coaches.notifications.buildAllReadPayload
import org.example.zone360.pages.dashboard.coaches.notifications.buildNotificationsPayload
import org.example.zone360.pages.dashboard.coaches.notifications.toUiModel
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Constants.DASHBOARD_HEADER_HEIGHT
import org.example.zone360.utils.Constants.FONT_FAMILY
import org.example.zone360.utils.Res
import org.example.zone360.utils.Strings
import org.example.zone360.utils.ToastID
import org.example.zone360.utils.getCurrentMilliseconds
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader
import org.example.zone360.utils.updateNotifications
import org.example.zone360.utils.uploadClubImage

@Composable
fun DashboardHeaderSection(
    toastMessage: (String) -> Unit = {},
    clubButton: Boolean = false,
    coachButton: Boolean = false,
) {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    val headerHeight by remember { mutableStateOf(DASHBOARD_HEADER_HEIGHT) }
    Box(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.headerBackgroundColor.rgb)
            .boxShadow(color = sitePalette.modalBackgroundColor.rgb, offsetX = 2.px, offsetY = 2.px)
            // AFTER
            .then(if (breakpoint >= Breakpoint.MD) Modifier.maxHeight(headerHeight.px) else Modifier),
        contentAlignment = Alignment.Center
    ) {
        Box(
            modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .fillMaxWidth().padding(
                    leftRight = if (window.screen.width > 600) 60.px else 10.px, topBottom = 3.px
                ), contentAlignment = Alignment.Center
        ) {
            DashboardHeader(
                toastMessage,
                clubButton = clubButton,
                coachButton = coachButton,
            )

        }
    }
}

@Composable
fun DashboardHeader(
    toastMessage: (String) -> Unit = {},
    clubButton: Boolean = false,
    coachButton: Boolean = false,
)
{
    val scope = rememberCoroutineScope()
    val ctx = rememberPageContext()
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    var showChangePasswordPopup by remember { mutableStateOf(false) }
    var showCancelSubscriptionPopup by remember { mutableStateOf(false) }
    var showChangeEmailPopup by remember { mutableStateOf(false) }
    var showAddDirectorPopup by remember { mutableStateOf(false) }
    var isImageUploading by remember { mutableStateOf(false) }
    var uploadedImageUrl by remember { mutableStateOf<String?>(null) }
    var showNotifications by remember { mutableStateOf(false) }
    val viewportWidth = window.innerWidth

    var notifications by remember { mutableStateOf<List<NotificationUiModel>>(emptyList()) }
    var unreadCount by remember { mutableStateOf(0L) }
    val isMobile = breakpoint < Breakpoint.MD
    val isDesktop = breakpoint >= Breakpoint.MD

    val showBellAfterClubButton = isMobile && clubButton
    val showBellAfterMenu = isDesktop || (isMobile && !clubButton)
    var skipFirst by remember { mutableStateOf(true) }

    LaunchedEffect(AppGlobal.updateNotifications) {
        if (skipFirst) {
            skipFirst = false
            return@LaunchedEffect
        }

        val payload = buildNotificationsPayload(
            role = AppGlobal.userData.role,
            userId = AppGlobal.userData.uid,
            organization = AppGlobal.userData.organization,
        )

        val response = getNotifications(payload)
        notifications = response.data.map { it.toUiModel() }
        unreadCount = response.unreadCount
    }

    if (showChangePasswordPopup) {
        ChangePasswordPage(
            onDialogDismiss = { showChangePasswordPopup = false },
            toastMessage = toastMessage
        )
    }
    if (showChangeEmailPopup) {
        ChangeEmailPage(
            onDialogDismiss = { showChangeEmailPopup = false },
            toastMessage = toastMessage
        )
    }
    if (showAddDirectorPopup) {
        AddDirector(
            onDialogDismiss = { showAddDirectorPopup = false },
            toastMessage = toastMessage
        )
    }

    if (showCancelSubscriptionPopup){
        CancelSubscriptionPopup(
            onDialogDismiss = { showCancelSubscriptionPopup = false },
            toastMessage = toastMessage
        )
    }
    LaunchedEffect(AppGlobal.imageUrl, AppGlobal.imageVersion) {
        if (AppGlobal.imageUrl.isNotBlank()) {
            val jsImg = js("new Image()")
            jsImg.crossOrigin = "anonymous"
            jsImg.src =
                "${Res.Images.base_Image_Url}${AppGlobal.imageUrl}?v=${AppGlobal.imageVersion}&nocache=${
                    js("Date.now()")
                }"
            jsImg.onload = {
                uploadedImageUrl = jsImg.src as String
            }
            jsImg.onerror = {
                uploadedImageUrl = Res.Images.userIcon
            }
        } else {
            uploadedImageUrl = Res.Images.userIcon
        }
    }

    val rightOffset = when {
        breakpoint >= Breakpoint.MD -> 400.px
        viewportWidth in 320..425 -> 325.px
        else -> 360.px
    }

    @Composable
    fun NotificationBellInline() {
        Box(
            modifier = Modifier
                .margin(left = 10.px, right = 10.px)
                .position(Position.Relative)
        ) {
            FaBell(
                modifier = Modifier
                    .size(15.px)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        showNotifications = true

                        if (unreadCount > 0) {
                            scope.launch {
                                try {
                                    updateNotifications(
                                        buildAllReadPayload(
                                            userId = AppGlobal.userData.id,
                                            organization = AppGlobal.userData.organization,
                                            markAs = "read",
                                            role = AppGlobal.userData.role
                                        )
                                    )
                                    unreadCount = 0
                                } catch (e: Throwable) {
                                    toastMessage("Read all notifications failed")
                                    showToast(ToastID.ERROR)
                                }
                            }
                        }
                    }
            )

            if (unreadCount > 0) {
                Box(
                    modifier = Modifier
                        .position(Position.Absolute)
                        .top((-9).px)
                        .right((-9).px)
                        .size(14.px)
                        .backgroundColor(sitePalette.primary.rgb)
                        .borderRadius(50.percent)
                        .zIndex(1),
                    contentAlignment = Alignment.Center
                ) {
                    SpanText(
                        text = if (unreadCount > 99) "99+" else unreadCount.toString(),
                        modifier = Modifier.fontSize(9.px).color(Colors.White)
                    )
                }
            }

            if (showNotifications) {

                // Overlay click → close
                Box(
                    modifier = Modifier
                        .position(Position.Fixed)
                        .top(0.px)
                        .left(0.px)
                        .width(100.percent)
                        .height(100.percent)
                        .zIndex(99998)
                        .onClick { showNotifications = false
                            AppGlobal.updateNotifications = getCurrentMilliseconds().toString()

                        }
                )

                Box(
                    modifier = Modifier
                        .position(Position.Absolute)
                        .top(30.px)
                        .right(rightOffset)
                        .zIndex(99999)
                ) {
                    NotificationsDropdown(
                        notifications = notifications,
                        onClose = { showNotifications = false
                            AppGlobal.updateNotifications = getCurrentMilliseconds().toString()

                        }
                    )
                }
            }
        }
    }
//    // ── Controls row (avatar + name + menu) ──────────────────────────────────
    @Composable
    fun ControlsRow() {
        Row(verticalAlignment = Alignment.CenterVertically) {
            // Club Dashboard button (desktop only — on mobile it goes in row 2 via second-row Row)
            if (clubButton && !isMobile) {
                Box(modifier = Modifier.margin(leftRight = 10.px)) {
                    CommonButton(
                        text = "Club Dashboard",
                        width = 120.px,
                        height = 37.px,
                        onCLick = { ctx.router.navigateTo("/home") }
                    )
                }
            }
            if (coachButton) {
                Box(modifier = Modifier.margin(leftRight = 10.px)) {
                    CommonButton(
                        text = "My Profile",
                        width = 80.px,
                        height = 37.px,
                        onCLick = { ctx.router.navigateTo("/coach-details?userId=${AppGlobal.userData.uid}") }
                    )
                }
            }

            // Avatar
            Box(contentAlignment = Alignment.CenterEnd) {
                when {
                    isImageUploading -> {
                        ShimmerCircle(
                            modifier = Modifier.size(38.px).margin(right = 8.px)
                                .borderRadius(100.px)
                                .border(width = 2.px, color = sitePalette.primary.rgb, style = LineStyle.Solid)
                        )
                    }
                    uploadedImageUrl != null -> {
                        Image(
                            src = uploadedImageUrl ?: Res.Images.userIcon,
                            modifier = Modifier.size(38.px).margin(right = 8.px)
                                .borderRadius(100.px)
                                .border(width = 2.px, color = sitePalette.primary.rgb, style = LineStyle.Solid)
                        )
                    }
                    else -> {
                        Image(
                            src = Res.Images.userIcon,
                            modifier = Modifier.size(38.px).margin(right = 7.px).borderRadius(100.px)
                        )
                    }
                }
                if (AppGlobal.userData.role == Strings.ADMIN && !isImageUploading) {
                    Image(
                        src = Res.Images.camera_icon,
                        modifier = Modifier.width(17.px)
                            .cursor(Cursor.Pointer)
                            .margin(right = 2.px, top = (-3).px)
                            .align(Alignment.TopEnd)
                            .onClick {
                                val input = document.getElementById(Res.Id.clubImage) as? HTMLInputElement
                                input?.click()
                            }
                    )
                }
            }

            // Name
            SpanText(
                if (AppGlobal.userData.role == Strings.ADMIN) {
                    AppGlobal.userData.organization.titleized()
                } else {
                    "${AppGlobal.userData.firstName.titleized()} ${AppGlobal.userData.lastName.titleized()}"
                },
                modifier = Modifier
                    .color(sitePalette.textFieldTextColor.rgb)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(15.px)
                    .margin(right = if (isMobile) 4.px else 8.px)
            )

            // Dropdown menu
            Box(Modifier.margin(right = 15.px)) {
                MenuDropdown(
                    icon = {
                        FaSortDown(modifier = Modifier.color(sitePalette.textFieldTextColor.rgb).margin(bottom = 7.px))
                    },
                    data = listOfNotNull(
                        if (AppGlobal.userData.role == Strings.ADMIN)
                            MenuModel(text = "Add Club Director", route = "")
                        else
                            null,

                        if (AppGlobal.userData.role == Strings.COACH)
                            MenuModel(text = "My Profile", route = "/coach-details")
                        else
                            null,

                        MenuModel(text = "Change Password", route = "/change-password"),
                        MenuModel(text = "Change Email", route = "/change-email"),

                        if (AppGlobal.userData.role == Strings.PLAYER &&
                            AppGlobal.userData.payment.subscription.status == Strings.ACTIVE &&
                            !AppGlobal.userData.payment.subscription.cancel_at_period_end
                        )
                            MenuModel(text = "Cancel Subscription", route = "")
                        else
                            null,

                        MenuModel(text = "Logout", route = "")
                    ),
//                    data = listOfNotNull(
//                        if (AppGlobal.userData.role == Strings.ADMIN) MenuModel(text = "Add Club Director", route = "") else null,
//                        MenuModel(text = "Change Password", route = "/change-password"),
//                        MenuModel(text = "Change Email", route = "/change-email"),
//                        if (AppGlobal.userData.role == Strings.COACH)
//                            MenuModel(text = "My Profile", route = "/coach-details") else null,
//                        if (AppGlobal.userData.role == Strings.PLAYER &&
//                            AppGlobal.userData.payment.subscription.status == Strings.ACTIVE &&
//                            !AppGlobal.userData.payment.subscription.cancel_at_period_end
//                        )
//                            MenuModel(text = "Cancel Subscription", route = "") else null
//                    ),
                    onSelect = {
                        when (it) {
                            "Change Password"      -> showChangePasswordPopup = true
                            "Change Email"         -> showChangeEmailPopup = true
                            "Add Club Director"    -> showAddDirectorPopup = true
                            "Cancel Subscription"  -> showCancelSubscriptionPopup = true
                            "My Profile"           -> ctx.router.navigateTo("/coach-details?userId=${AppGlobal.userData.uid}")
                            "Logout" -> {
                                localStorage.clear()
                                AppGlobal.imageUrl = ""
                                AppGlobal.userData = UserData()
                                AppGlobal.selectedSeasonId = ""
                                AppGlobal.selectedSeason = ""
                                ctx.router.navigateTo("/login")
                            }
                        }
                    }
                )
            }

            // Bell — shown on desktop here; on mobile it lives in the logo row
            if (!isMobile) {
                NotificationBellInline()
            }
        }
    }

    //    // ── Root layout ───────────────────────────────────────────────────────────
    if (isMobile) {
        com.varabyte.kobweb.compose.foundation.layout.Column(
            modifier = Modifier.fillMaxWidth()
        ) {
            // ROW 1 — Logo + Bell
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Image(
                    src = Res.Images.logosvg,
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .width(140.px)
                        .height(40.px)
                        .onClick {
                            if (AppGlobal.userData.role != Strings.PLAYER &&
                                AppGlobal.userData.organization != Strings.INDEPENDENT
                            ) ctx.router.navigateTo("/home")
                        }
                )
                NotificationBellInline()
            }

            // ROW 2 — Controls
            Row(
                modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            ) {
                if (clubButton) {
                    Box(modifier = Modifier.margin(right = 10.px)) {
                        CommonButton(
                            text = "Club Dashboard",
                            width = 120.px,
                            height = 37.px,
                            onCLick = { ctx.router.navigateTo("/home") }
                        )
                    }
                }
                ControlsRow()
            }
        }
    } else {
        // Desktop — single row unchanged
        Row(
            modifier = Modifier.width(100.percent),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Image(
                src = Res.Images.logosvg,
                modifier = Modifier
                    .cursor(Cursor.Pointer)
                    .color(sitePalette.primary.rgb)
                    .width(140.px)
                    .height(140.px)
                    .onClick {
                        if (AppGlobal.userData.role != Strings.PLAYER &&
                            AppGlobal.userData.organization != Strings.INDEPENDENT
                        ) ctx.router.navigateTo("/home")
                    }
            )
            ControlsRow()
        }
    }

    Input(
        type = InputType.File,
        attrs = {
            id(Res.Id.clubImage)
            attr("accept", "image/*")
            style { display(DisplayStyle.None) }
            onChange { event ->
                val file = event.target.files?.item(0)

                if (file != null) {
                    // Optional: Preview image in UI
                    val reader = FileReader()
                    reader.onload = { e ->
                        val base64 = e.target?.asDynamic()?.result as? String
                        if (base64 != null) {
                            uploadedImageUrl = base64 // your mutable state
                        }
                    }
                    reader.readAsDataURL(file)

                    // Upload to server
                    scope.launch {
                        isImageUploading = true
                        try {
                            val response = uploadClubImage(
                                file = file,
                                organization = AppGlobal.userData.organization
                            )
                            AppGlobal.userData =
                                AppGlobal.userData.copy(imageUrl = response.data.imageUrl)
                            AppGlobal.imageUrl = response.data.imageUrl
                        } catch (e: Exception) {
                            debugPrintln(" Upload failed: $e")
                        } finally {
                            isImageUploading = false
                        }
                    }
                }
            }
        }
    )

}
